import { render, staticRenderFns } from "./BurstData.html.vue?vue&type=template&id=6aacb509"
import script from "./BurstData.html.vue?vue&type=script&lang=js"
export * from "./BurstData.html.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/burstData/index.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/burstData/index.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports